import $ from 'jquery';

class Validator {
    constructor($form) {
        this.$form = $form;

        // Remove the `required` attribute to disable the browser's form validation.
        this.$requiredChecks = this.$form.find('input[required]').removeAttr('required');
    }

    /**
     * Checks required fields to determine if all are checked or filled out and returns a boolean
     *  indicating if the form is valid or not. If a required field is unchecked or empty, displays
     *  an error message. This error message can be edited in the markup of the required form field
     *  by adding a `data-error` parameter to the element.
     * @return boolean
     */
    validateForm() {
        $('.js-validation-error').remove();

        $('#contact-form').addClass('disabled');

        $('#contact-form input[type="submit"]')
            .attr('disabled', true)
            .val('Submitting...');

        // required checkboxes are valid
        const checksValid = this._validateRequiredChecks();

        return checksValid;
    }

    /**
     * Helper function to validate required checkboxes. If any required checkboxes are unchecked,
     *  this will return false. A checkbox input can be indicated as required by adding the
     *  `required` attribute to the element. Validation error messages can be edited by adding a
     *  `data-error` attribute to the required checkbox input element.
     * @return boolean
     */
    _validateRequiredChecks() {
        let valid = true;

        this.$requiredChecks.each((i, input) => {
            // if checked, it's valid, so skip
            if (input.checked) {
                return true;
            }

            // otherwise, the form is invalid
            valid = false;

            // print out the error message
            const errorMsg = $(input).data('error') || 'This field is required';
            $(input)
                .closest('.form__check')
                .after(`<p class="js-validation-error form__checkerror">${errorMsg}</p>`);
        });

        return valid;
    }
}

export default Validator;
